export const READY = 'READY';
export const COMPLETED = 'COMPLETED';
export const RUNNING = 'RUNNING';
export const FAILED = 'FAILED';
